<script lang="ts">
      import BlockWidth from '../blocks/BlockWidth.svelte'
      import RenderBlock from '../blocks/RenderBlock.svelte'
      import LexicalBlock from '../lexical/LexicalBlock.svelte'
      import LexicalRender from '../lexical/LexicalRender.svelte'
      import { getLocaleContext } from '../locale/ts/Locale.svelte'
      import { getMetaContext } from '../metatags/ts/MetaContext.svelte'
      import ProgramItem from './ProgramItem.svelte'
      import RolesBlock from './Roles/RolesBlock.svelte'

      let { item } = $props()

      const locale = getLocaleContext()

      let creativeTeam = $derived.by(() => {
            let _title = item.creativeTeamLabel
            if (!_title)
                  return {
                        default: 'kreativní tým',
                        en: 'creative team',
                  }
            return {
                  default: _title,
                  en: _title,
            }
      })

      let cast = $derived.by(() => {
            let _title = item.castLabel
            if (!_title)
                  return {
                        default: 'obsazení',
                        en: 'cast',
                  }
            return {
                  default: _title,
                  en: _title,
            }
      })


      let creativeTeamLabel = $derived.by( () => {
        if ( ! item.catalogue?.creativeTeamLabel || item.catalogue?.creativeTeamLabel == "" ) return null
        return item.catalogue.creativeTeamLabel
      })

      let castLabel = $derived.by( () => {
        if ( ! item.catalogue?.castLabel || item.catalogue?.castLabel == "" ) return null
        return item.catalogue.castLabel
      })
</script>

<BlockWidth>
      <ProgramItem {item}></ProgramItem>
</BlockWidth>

<BlockWidth>
      <LexicalRender root={ locale.locale == "cs" ? item.note_before_cs?.root : item.note_before_en?.root}></LexicalRender>
</BlockWidth>

{#each item.catalogue?.content as block, i}
      <RenderBlock {block}></RenderBlock>
{/each}

<BlockWidth>
      <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
            {#if item.catalogue?.creativeTeam?.length > 0}
                  <RolesBlock roles={item.catalogue?.creativeTeam} title={creativeTeamLabel ?? locale.ŧ(creativeTeam)}></RolesBlock>
            {/if}
            {#if item.catalogue?.cast?.length > 0}
                  <RolesBlock roles={item.catalogue?.cast} title={castLabel ?? locale.ŧ(cast)}></RolesBlock>
            {/if}
      </div>
</BlockWidth>

<BlockWidth>
      <LexicalRender root={locale.locale == "cs" ? item.note_after_cs?.root : item.note_after_en?.root}></LexicalRender>
</BlockWidth>

<style lang="postcss">
</style>
